import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import FlyOutHeader from '@nerdwallet/react-fly-out-header';
import brandData from './data/brand-data';

import {
  stringInputSpec,
  boolCheckboxSpec,
  repeatable,
} from '../../lib/editing-configs';

const EditableFlyOutHeader = ({ pageSection, sections, useBrandData }) => {
  useEffect(() => {
    const body = document?.querySelector('body');
    body.style.paddingTop = '3.75rem';
    return () => {
      body.style.removeProperty('padding-top');
    };
  }, []);
  const data = useBrandData ? brandData : sections;
  return <FlyOutHeader sections={data} pageSection={pageSection} />;
};

EditableFlyOutHeader.propTypes = {
  pageSection: PropTypes.string,
  useBrandData: PropTypes.bool,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
      subsections: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          url: PropTypes.string,
        })
      ),
    })
  ),
};

EditableFlyOutHeader.defaultProps = {
  pageSection: '',
  sections: [],
};

EditableFlyOutHeader.getEditingConfig = (componentDocument) => {
  const sectionsConfig = componentDocument?.props?.useBrandData
    ? []
    : [
        repeatable('sections', 'Sections', 'Section', (item) => {
          const section = componentDocument?.props?.sections[item];
          const subSectionConfig = section?.addSubsections
            ? [
                repeatable('subsections', 'Sub Sections', 'Sub Section', () => [
                  stringInputSpec('name', 'Sub Section Name'),
                  stringInputSpec('url', 'Sub Section URL'),
                ]),
              ]
            : [stringInputSpec('url', 'Section URL')];
          return [
            stringInputSpec('name', 'Name'),
            boolCheckboxSpec('addSubsections', 'Add Subsections?'),
            ...subSectionConfig,
          ];
        }),
      ];
  return [
    stringInputSpec('pageSection', 'Page Section'),
    boolCheckboxSpec('useBrandData', 'Use brand site nav?'),
    ...sectionsConfig,
  ];
};

EditableFlyOutHeader.displayName = 'EditableFlyOutHeader';

export default EditableFlyOutHeader;
